"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiTypography = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _TypographyText = _interopRequireDefault(require("../TypographyText/TypographyText"));

var _MuiIcon = _interopRequireDefault(require("../MuiIcon/MuiIcon"));

var _customProps = require("../../utils/customProps");

var _MuiIconButtonRedirect = _interopRequireDefault(require("../MuiIconButtonRedirect/MuiIconButtonRedirect"));

var _MuiIconButtonHref = _interopRequireDefault(require("../MuiIconButtonHref/MuiIconButtonHref"));

var _MuiIconButtonDownload = _interopRequireDefault(require("../MuiIconButtonDownload/MuiIconButtonDownload"));

var _MuiButtonRedirect = _interopRequireDefault(require("../MuiButtonRedirect/MuiButtonRedirect"));

var _MuiButtonHref = _interopRequireDefault(require("../MuiButtonHref/MuiButtonHref"));

var _MuiButtonDownload = _interopRequireDefault(require("../MuiButtonDownload/MuiButtonDownload"));

var _MuiLink = _interopRequireDefault(require("../MuiLink/MuiLink"));

var _MuiButtonDialog = _interopRequireDefault(require("../MuiButtonDialog/MuiButtonDialog"));

var _MuiIconButtonDialog = _interopRequireDefault(require("../MuiIconButtonDialog/MuiIconButtonDialog"));

var _GoogleConversions = _interopRequireDefault(require("../GoogleConversions/GoogleConversions"));

/**
 * MuiTypography
 */
var MuiTypography = function MuiTypography(props) {
  var components = {
    MuiLink: _MuiLink.default,
    MuiIcon: _MuiIcon.default,
    MuiIconButtonRedirect: _MuiIconButtonRedirect.default,
    MuiIconButtonHref: _MuiIconButtonHref.default,
    MuiIconButtonDownload: _MuiIconButtonDownload.default,
    MuiIconButtonDialog: _MuiIconButtonDialog.default,
    MuiButtonRedirect: _MuiButtonRedirect.default,
    MuiButtonHref: _MuiButtonHref.default,
    MuiButtonDownload: _MuiButtonDownload.default,
    MuiButtonDialog: _MuiButtonDialog.default,
    GoogleConversions: _GoogleConversions.default
  };
  return /*#__PURE__*/_react.default.createElement(_TypographyText.default, (0, _extends2.default)({}, props, {
    components: components
  }));
};

exports.MuiTypography = MuiTypography;
var _default = MuiTypography;
exports.default = _default;
MuiTypography.propTypes = {
  content: function content(props, propName, componentName) {
    var components = ['MuiLink', 'MuiIcon', 'MuiIconButtonRedirect', 'MuiIconButtonHref', 'MuiIconButtonDownload', 'MuiIconButtonDialog', 'MuiButtonRedirect', 'MuiButtonHref', 'MuiButtonDownload', 'MuiButtonDialog', 'GoogleConversions'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  }
};
MuiTypography.defaultProps = {
  content: []
};